<script>
import lazyLoadComponent from '@router/lazyload-component'
import { formatGetTime } from '@utils/format-date'


const initData = () => {
  return {
    avatar: '',
    name: '',
    title: '',
    phoneCode: '+886',
    phoneNumber: '',
    specialty: '',
    certificate: '',
    description: '',
    password: '',
    passwordConfirm: '',
    takeOfficeDate: '',
    leaveOfficeDate: '',
    block: 0,
  }
}
export default {
  components: {
    BaseInputFloatingLabel: () => lazyLoadComponent(import('@components/BaseInputFloatingLabel')),
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
    CountryCodePicker: () => lazyLoadComponent(import('@components/CountryCodePicker')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
  },
  data() {
    return {
      tryingStore: false,
      submitData: Object.assign(initData(), this.defaultValue),
      endDatePickerOptions: {
        disabledDate: (time) => {
          // check String or Date Object
          const selectedStartDate = this.submitData.takeOfficeDate instanceof Object ? this.submitData.takeOfficeDate : new Date(this.submitData.takeOfficeDate)
          const limitWith365Days = selectedStartDate.getTime() + 3600 * 1000 * 24 * 365
          return time < selectedStartDate || time.getTime() >= limitWith365Days
        },
      },
      passwordVisible: false,
      repasswordVisible: false,
    }
  },
  computed: {
    submitRules() {
      const isTaiwan = this.submitData.phoneCode === '+886'
      return {
        avatar: [
          {
            required: true,
            message: '請上傳頭像',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: '請填寫姓名',
            trigger: 'blur',
          },
        ],
        email: [{ required: true, message: '請輸入 Email' }, { type: 'email', message: '請輸入正確的 Email 格式' }],
        password: [
          {
            required: !this.isEditMode,
            message: '請輸入密碼',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              const passwordPattern = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])(?=.*[$@$!%*#?&])|(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*#?&])|(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&]).{8,16}/
              if (!passwordPattern.test(value)) {
                callback(new Error('請用 8~16 個大小寫英文字母、數字與特殊符號組合'))
              }
              if (this.submitData.passwordConfirm !== '') {
                this.$refs.form.validateField('passwordConfirm')
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
        passwordConfirm: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) return callback(new Error('請再次輸入密碼'))
              const passwordValue = this.submitData.password
              if (value !== passwordValue) {
                callback(new Error('兩次輸入的密碼不一致'))
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: '請填寫職位',
            trigger: 'blur',
          },
        ],
        phoneCode: [
          {
            required: true,
            message: '請選擇電話國碼',
            trigger: 'change',
          },
        ],
        phoneNumber: [
          {
            required: true,
            message: '請填寫聯絡電話',
            trigger: 'blur',
          },
          {
            pattern: isTaiwan ? /^02\d{7,8}$|^09\d{8}$/ : '',
            message: '市話號碼格式請符合 02XXXXXXXX；手機號碼格式請符合 09XXXXXXXX',
            trigger: 'blur',
          },
        ],
        takeOfficeDate: [
          {
            validator: (rule, value, callback) => {
              if (this.submitData.takeOfficeDate) this.$refs.form.validateField('leaveOfficeDate')

              callback()
            },
            trigger: 'change',
          },
        ],
        leaveOfficeDate: [
          {
            validator: (rule, value, callback) => {
              if (this.submitData.takeOfficeDate && !!value) {
                const isSmallThanTakeOfficeDate = formatGetTime(this.submitData.takeOfficeDate) > formatGetTime(value)
                if (isSmallThanTakeOfficeDate) return callback(new Error('不得小於到職日期'))
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      }
    },
    isEditMode() {
      return this.defaultValue.id
    },
  },
  watch: {
    defaultValue: 'updateSubmitData',
  },
  methods: {
    async tryToStore() {
      await this.$refs.form.validate()
      this.tryingStore = true
      try {
        if (!this.isEditMode) {
          const newStaff = await this.$store.dispatch('schedule/storeStaff', this.submitData)
          this.emitStore(newStaff)
        } else {
          await this.$store.dispatch('schedule/storeStaff', this.submitData)
          this.emitStore()
        }
      } catch (error) {
        console.log('TCL: tryToStore -> error', error)
      } finally {
        this.tryingStore = false
      }
    },
    emitStore(newStaff = '') {
      this.$emit('store', newStaff)
      this.emitClose()
    },
    emitClose() {
      this.$emit('close')
      this.$refs.form.resetFields()
    },
    updateSubmitData() {
      this.submitData = Object.assign({}, this.defaultValue)
    },
  },
}
</script>

<template>
  <div>
    <el-form ref="form" :model="submitData" :rules="submitRules" label-position="top" class="el-form--floating" :validate-on-rule-change="false">
      <el-form-item prop="avatar">
        <BaseUpload v-model="submitData.avatar" resource="staff" circle suggest-size="128/128" />
      </el-form-item>
      <el-form-item label="帳號啟用" prop="block">
        <el-switch v-model="submitData.block" active-text="啟用" inactive-text="停權" :active-value="0" :inactive-value="1" :disabled="defaultValue.canBlock === 0"></el-switch>
        <el-alert v-if="defaultValue.canBlock === 0" title="欲停權帳號請先轉移隸屬此帳號的有效訂單" type="warning" style="display: inline; margin-left: 20px;" :closable="false" show-icon> </el-alert>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <BaseInputFloatingLabel v-model="submitData.name" />
      </el-form-item>
      <el-form-item label="Email" prop="email">
        <BaseInputFloatingLabel v-model="submitData.email" />
      </el-form-item>
      <el-form-item v-if="!isEditMode" label="密碼" prop="password">
        <BaseInputFloatingLabel v-model="submitData.password" :type="passwordVisible ? 'text' : 'password'" autocomplete="off">
          <template v-slot:append>
            <el-button @click="passwordVisible = !passwordVisible">
              <BaseIcon :name="passwordVisible ? 'eye-slash' : 'eye'" />
            </el-button>
          </template>
        </BaseInputFloatingLabel>
      </el-form-item>
      <el-form-item v-if="!isEditMode" label="確認密碼" prop="passwordConfirm">
        <BaseInputFloatingLabel v-model="submitData.passwordConfirm" :type="repasswordVisible ? 'text' : 'password'" autocomplete="off">
          <template v-slot:append>
            <el-button @click="repasswordVisible = !repasswordVisible">
              <BaseIcon :name="repasswordVisible ? 'eye-slash' : 'eye'" />
            </el-button>
          </template>
        </BaseInputFloatingLabel>
      </el-form-item>
      <el-form-item label="職位" prop="title">
        <BaseInputFloatingLabel v-model="submitData.title" />
      </el-form-item>
      <el-form-item label="到職日期" prop="takeOfficeDate">
        <el-date-picker v-model="submitData.takeOfficeDate" type="date" format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      <el-form-item label="離職日期" prop="leaveOfficeDate">
        <el-date-picker v-model="submitData.leaveOfficeDate" :picker-options="endDatePickerOptions" type="date" format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      <el-form-item label="聯絡電話" prop="phoneNumber">
        <el-input v-model="submitData.phoneNumber">
          <CountryCodePicker slot="prepend" v-model="submitData.phoneCode" />
        </el-input>
      </el-form-item>
      <el-form-item label="證照" prop="certificate">
        <BaseInputFloatingLabel v-model="submitData.certificate" />
      </el-form-item>
      <el-form-item label="專長" prop="specialty">
        <BaseInputFloatingLabel v-model="submitData.specialty" />
      </el-form-item>
      <el-form-item label="介紹" prop="description">
        <BaseInputFloatingLabel v-model="submitData.description" type="textarea" :autosize="{ minRows: 2 }" />
      </el-form-item>
    </el-form>
    <div :class="$style.footer">
      <el-button class="is-round" @click="emitClose">取消</el-button>
      <el-button class="is-round" type="primary" :loading="tryingStore" @click="tryToStore">{{ isEditMode ? '儲存' : '創建' }}</el-button>
    </div>
  </div>
</template>
<style lang="scss" module>
.footer {
  text-align: right;
}
</style>
